import moment from "moment";
import React from "react";
// import SmartTable from "../../Component/Common/SmartTable";
import { DATETIMEFORMAT, TYPESOFORDERS } from "../../contants/index";

import "./invoice.css";
// const printheaders = [
//   { title: "SKU", key: "sku", type: "text", currency: false },
//   { title: " Item", key: "product", type: "text", currency: false },

//   {
//     title: "Unit Price",
//     key: "unitPrice",
//     type: "float",
//   },
//   {
//     title: "Quantity",
//     key: "requestedQuantity",

//     type: "number",
//   },
//   {
//     title: "Discount",
//     key: "discountRate",
//     type: "number",
//   },
//   {
//     title: "Dis.Amount",
//     key: "discountAmount",
//     type: "float",
//   },

//   { title: "Tax Rate", key: "taxRate", type: "float", currency: false },
//   {
//     title: "Tax Amount",
//     key: "taxAmount",
//     type: "float",
//   },
//   {
//     title: "Total",
//     key: "totalAmount",
//     type: "float",
//   },
// ];
const printfooters = [
  {
    title: "Total",
    hasCurrency: false,
    key: "totalQuantity",
    titleClass: "grand",
    valueClass: "grandtotal",
  },
];

const Header = ({
  branchOrderNumber,
  customerName,
  customerMobile,

  resName,
  orderDate,
  paymentType,
  logo,
  tableNumber,
  gstNumber,
  branchAddress,
  orderType,
  orderTypeId,
  kotNumber,
}) => {
  return (
    <>
      <div className="centered">
        <p>{resName}</p>
        {branchAddress && <p className="gstNumber">{branchAddress}</p>}
        {gstNumber && <p className="gstNumber">GST {gstNumber}</p>}
      </div>

      <div className="info">
        {customerName && (
          <div className="subinfo">
            <p>
              Name : {customerName}{" "}
              {customerMobile ? `(${customerMobile})` : ""}
            </p>
          </div>
        )}
        <div className="subinfo">
          <p>{moment().format("DD/MM/YYYY HH:mm")}</p>

          <p>Token : {kotNumber}</p>
        </div>
        <div className="subinfo">
          <p>{orderType}</p>

          {tableNumber && <p>Table : {tableNumber}</p>}
        </div>
      </div>
    </>
  );
};

const renderRow = (data, value) => {
  return value ? (
    <tr>
      <td colspan="2" className={data.titleClass}>
        {data.title}
      </td>
      <td colspan="2" className={data.valueClass}>
        {data.hasCurrency ? "₹" : " "} {value}
      </td>
    </tr>
  ) : (
    ""
  );
};

const renderItem = (value, index, i) => {
  let toppings = [];
  if (value?.activeTopping?.length > 0) {
    value?.activeTopping?.map((topping) => toppings.push(topping.itemName));
  }
  return (
    <React.Fragment key={index}>
      <tr>
        <td className="sr">{i}</td>
        <td className="pro">{value.itemName}</td>
        <td className="quantity">{value.quantity}</td>
      </tr>
      {value?.activeTopping?.length > 0 && (
        <tr>
          <td className="sr">-</td>
          <td className="pro topping-font">{toppings.join(",")}</td>
        </tr>
      )}
    </React.Fragment>
  );
};
const ProductTable = ({ orderData }) => {
  let totalQuantity = 0;
  return (
    <table className="postable">
      <thead>
        <tr>
          <th className="sr">Sr.</th>
          <th className="pro">Product</th>
          <th className="quantity">Qty</th>
        </tr>
      </thead>
      <tbody>
        {orderData.orderItems.map((value, index) => {
          const i = ++index;
          totalQuantity += value.quantity;
          return renderItem(value, index, i);
        })}

        {printfooters.map((foot, footIndex) => renderRow(foot, totalQuantity))}
      </tbody>
    </table>
  );
};

const Invoice = React.forwardRef(
  (
    {
      restaurant,
      orderData,
      count,
      logo,
      gstNumber,
      receiptMessage,
      branchAddress,
    },
    ref,
  ) => {
    const {
      branchOrderNumber,
      customerName,
      customerMobile,

      orderNumber,
      paymentType,
      createdAt,
      tableNumber,
      orderType,
      orderDate,
      remarks,
    } = orderData;
    return (
      <div className="ticket" ref={ref}>
        <Header
          resName={restaurant}
          branchOrderNumber={branchOrderNumber}
          orderNumber={orderNumber}
          customerName={customerName}
          customerMobile={customerMobile}
          paymentType={paymentType}
          orderDate={orderDate}
          tableNumber={tableNumber}
          orderType={orderType}
          logo={logo}
          gstNumber={gstNumber}
          branchAddress={branchAddress}
          kotNumber={orderData?.KOTS[orderData?.KOTS?.length - 1]?.kotNumber}
        />
        <ProductTable
          orderData={orderData?.KOTS[orderData?.KOTS?.length - 1]}
        />
        {remarks && (
          <p>
            <p style={{ fontSize: "25px" }}>Remarks : {remarks}</p>
          </p>
        )}
      </div>
    );
  },
);

class BillComponent extends React.Component {
  render() {
    const {
      logo,
      orderData,
      count,
      restaurant,
      gstNumber,
      receiptMessage,
      branchAddress,
    } = this.props;
    return orderData ? (
      <Invoice
        count={count}
        restaurant={restaurant}
        orderData={orderData}
        logo={logo}
        gstNumber={gstNumber}
        receiptMessage={receiptMessage}
        branchAddress={branchAddress}
      />
    ) : (
      <div className={`invoice-box invoice-box-hide" `}>No Data found</div>
    );
  }
}
export default BillComponent;
